export const SOLSEA_ESCROW_ACCOUNT_SIZE = 600;
//TODO@goran:try to find fx which calculate rent for given data size
export const SOLSEA_ESCROW_RENT = 50066880;
